export function autoKoicon(seed: string) {
  if (seed) {
    let no = (Math.abs(hashCode(seed)) % 52) + 2
    return `koicon/koicon-${padding(no, 2)}`
  } else {
    return ''
  }
}

export function patchKoiconName(iconName: string) {
  if (iconName.startsWith('koicon-')) {
    if (iconName.startsWith('koicon-01')){
      return 'koicon/koicon-07';
    }
    return `koicon/${iconName}`;
  }
  return iconName;
}
